import { Select } from '@zillow/constellation-10';

const STATES_AND_TERRITORIES_ABBREVIATED = [
  'AA',
  'AE',
  'AK',
  'AL',
  'AP',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'FM',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MH',
  'MI',
  'MN',
  'MO',
  'MP',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'PW',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];

const EXTENDED_TERRITORIES_ABBREVIATED_ARRAY = ['AA', 'AE', 'AP', 'MH', 'FM', 'MP', 'PW'];

const INIT_TEXT = 'Please select';

function getAbbreviatedOptions() {
  const result = STATES_AND_TERRITORIES_ABBREVIATED.filter(
    (state) => !EXTENDED_TERRITORIES_ABBREVIATED_ARRAY.includes(state),
  );
  return result.map((stateName) => (
    <option key={stateName} value={stateName}>
      {stateName}
    </option>
  ));
}

function getOptions() {
  const stateOptions = getAbbreviatedOptions();
  stateOptions.unshift(
    <option key="INIT" value="">
      {INIT_TEXT}
    </option>,
  );
  return stateOptions;
}

const UnitedStatesSelect = (props) => {
  const { onChange, value, error, ...rest } = props;

  return (
    <Select onChange={onChange} value={value} error={error} {...rest}>
      {getOptions()}
    </Select>
  );
};

export default UnitedStatesSelect;
